module.exports = __webpack_public_path__ + "img/bukaka.5caecc73.jpg";